import { z } from 'zod';

/**
 * v2 신규/확장 API 공통 스키마.
 *
 * 2026-08-08 백엔드 swagger(InDrive API v1, NSwag) 기준으로 확정 반영.
 * zod parse가 런타임에 계약 어긋남을 바로 드러내므로, 스펙이 바뀌면 여기부터 수정.
 */

/** 서버 공통 페이지네이션 필드 (PaginatedListOf* — shared CommonPaginationResponse와 동일) */
export const paginationFieldsSchema = z.object({
  pageNumber: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
  totalCount: z.number(),
  hasPreviousPage: z.boolean(),
  hasNextPage: z.boolean(),
});

/** 페이지네이션 envelope — items + 페이지 정보 */
export const pagedSchema = <T extends z.ZodTypeAny>(item: T) =>
  paginationFieldsSchema.extend({ items: z.array(item) });

/** 폴더 권한 (shared ArchivePermission · swagger enum과 동일 값) */
export const archivePermissionSchema = z.enum([
  'Manage',
  'Upload',
  'Download',
  'Read',
]);
export type V2ArchivePermission = z.infer<typeof archivePermissionSchema>;

// #region N13/N15 — 비동기 ZIP 다운로드 작업
export const bulkDownloadStatusSchema = z.enum([
  'Pending',
  'Processing',
  'Completed',
  'Failed',
  'Empty',
]);
export type BulkDownloadStatus = z.infer<typeof bulkDownloadStatusSchema>;

/** POST 생성 응답 (BulkDownloadCreatedResponse) — 생성 시점에 상태·건수까지 온다 */
export const bulkDownloadCreatedSchema = z.object({
  jobId: z.string(),
  status: bulkDownloadStatusSchema,
  totalCount: z.number(),
  /** 권한 없어 제외된 항목 수 → "일부 누락" 경고 표시용 */
  skippedCount: z.number(),
  /**
   * 권한 없어 제외된 파일 id — **작업 생성 응답에만** 온다(작업 조회 GET에는 없음 · 백엔드 #25).
   * 받은 항목만 장바구니에서 빼는 데 쓴다(F8).
   */
  skippedFileIds: z.array(z.number()).nullish(),
});
export type BulkDownloadCreated = z.infer<typeof bulkDownloadCreatedSchema>;

/** GET 폴링 응답 (BulkDownloadStatusResponse) — Completed면 url·fileName·expiresAt */
export const bulkDownloadJobSchema = bulkDownloadCreatedSchema.extend({
  fileName: z.string().nullish(),
  url: z.string().nullish(),
  errorMessage: z.string().nullish(),
  expiresAt: z.string().nullish(),
});
export type BulkDownloadJob = z.infer<typeof bulkDownloadJobSchema>;
// #endregion
